import reportApi from '~/clientApis/reportApi';
import { showMessageModal } from '~/clientUtils/showMessageModal';
import { CandidateScoreData } from '~/definitions/report';
import { getStore } from '~/mobx/AppStore';

export const getCandidateScoreListByRegion = async () => {
    const { reportStore, regionStore, candidateStore } = getStore();

    reportStore.setIsGettingCandidateScoreList(true);

    try {
        const response = await reportApi.getCandidateScoreListByRegion(regionStore.selectedRegionId);

        const data: CandidateScoreData[] = response?.data ?? [];

        data.sort(candidateStore.sortCandidates);

        reportStore.setVotesList(data);
    } catch (error) {
        const errorMessage =
            (await (error as Response).json()).error ||
            'Error fetching candidate score list by region id: ' + regionStore.selectedRegionId;
        showMessageModal('error', errorMessage);
    } finally {
        reportStore.setIsGettingCandidateScoreList(false);
    }
};
